import { Link, LinkUse, Text, TypographyProps } from '@growtherapy/sprout-ui';

import { logger } from '../datadog';

function parseLinks(text: string, linkUse = LinkUse.Default): (string | JSX.Element)[] {
  try {
    const LINK_REGEX = /\[([^\]]+)\]\(((https?:\/\/|\/)[^\s)]+?)\)/g;
    const result: (string | JSX.Element)[] = [];

    let lastIndex = 0;
    let match: RegExpExecArray | null;

    while ((match = LINK_REGEX.exec(text)) !== null) {
      const [fullMatch, title, url] = match;

      if (match.index > lastIndex) {
        result.push(text.slice(lastIndex, match.index));
      }

      result.push(
        <Link key={result.length} href={url} target='_blank' use={linkUse}>
          {title}
        </Link>,
      );

      lastIndex = match.index + fullMatch.length;
    }

    if (lastIndex < text.length) {
      result.push(text.slice(lastIndex));
    }

    return result;
  } catch (error) {
    // Fallback to the original text if parsing fails
    logger.error('[MarkdownLinkify] Error parsing markdown links:', {}, error as Error);
    return [text];
  }
}

/** A simple component that will parse markdown-styled links and return them as real sprout Link elements. This is not a true markdown
 * parser at all, but is a simple solution to a very complex problem. If anything more than some basic parsing is needed, use a real
 * markdown parser.
 * */
export function MarkdownLinkify(props: TypographyProps & { markdown: string; linkUse?: LinkUse }): JSX.Element {
  const { markdown, linkUse, ...rest } = props;
  return <Text {...rest}>{parseLinks(markdown, linkUse)}</Text>;
}
